import { Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";

export const Layout = styled.div`
  margin: 0 auto;
  max-width: 100%;
  text-align: center;
`;

export const H3 = styled(Typography.Title)`
  margin: 18px 0 16px;
`;

export const Paragraph = styled(Typography.BodyText)`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 15px;
  line-height: 24px;
`;
export const NoServicesParagraph = styled(Typography.BodyText)`
  margin: 0;
  font-size: 15px;
  line-height: 24px;
`;
export const Illustration = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  width: 100px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NoServicesIllustration = styled(Illustration)`
  margin-top: 56px;
`;

export const H2 = styled(Typography.Title)`
  text-transform: capitalize;
`;

export const Documentationlink = styled(Button)`
  &:hover {
    color: var(--mode-text-primary-default);
  }
  &:hover:after {
    background-color: var(--mode-text-primary-default);
  }
`;
